<template>
  <div id="promo">
    <div class="hidden-xs">
      <div class="text">
        <h1 class="lose">{{ $t('promo.loseIt') }}</h1>
        <h1 class="have">{{ $t('promo.gotIt') }}</h1>
      </div>
      <img class="laptop" src="/img/icons/Promo/laptop-full.png">
      <div class="download">
        <p>{{ $t('promo.typeDesktop') }}<br>{{ $t('promo.downloadDesktop') }}<b>{{ $t('promo.encryptedBackupApplication') }}</b>{{ $t('promo.neverLose') }}</p>
        <div class="botones">
          <router-link class="info" :to="redirect" :aria-label="$t('promo.skipStep')" :title="$t('promo.skipStep')">
          <span>{{ $t('promo.skipStep') }}</span>
          </router-link>
          <a class="download-button" :href="getSO" @click="redirectInfo" target="_blank">
            <span>{{ $t('buttons.download') }}</span>
          </a>
        </div>
      </div>
      <div class="header">
        <a href="https://www.iberbox.com"><img src="/img/icons/icono_blanco_sin_texto.png" alt="IBERBOX"></a>
        <p class="logo">IBERBOX</p>
      </div>
    </div>
    <div class="visible-xs">
      <div class="contenedor-blanco">
        <a href="https://www.iberbox.com"><img src="/img/icons/Promo/IberboxLogo.svg" alt="IBERBOX"></a>
        <h1 class="lose">{{ $t('promo.loseIt') }}</h1>
      </div>
      <img class="laptop" src="/img/icons/Promo/laptop-full.png">
      <div class="contenedor-azul">
        <h1 class="have">{{ $t('promo.gotIt') }}</h1>
        <div class="download">
          <p>{{ $t('promo.typeDesktop') }}<br>{{ $t('promo.downloadDesktop') }}<b>{{ $t('promo.encryptedBackupApplication') }}</b>{{ $t('promo.neverLose') }}</p>
          <router-link class="download-button" to="/cloud">
            <span>{{ $t('buttons.understood') }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { files as ibbapi } from '@/api';
import {mapGetters} from 'vuex';

export default {
  name: 'promo',
  data: function() {
    return {
      paymentMethod: 0
    };
  },
  async mounted () {
    if (this.isLogged) {
      try {
        let action = await ibbapi.getInvoicing();
        this.paymentMethod = action.credit;
      } catch (e) {
        this.$showError(e);
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLogged'
    ]),
    getSO() {
      let platform = window.navigator.platform;
      let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
      let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

      if (macosPlatforms.indexOf(platform) !== -1) {
        return 'https://apps.apple.com/es/app/iberbox/id1529650281';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        return 'https://www.iberbox.com/downloads/IberboxInstaller.exe';
      } else if (/Linux/.test(platform)) {
        return 'https://snapcraft.io/iberbox';
      }
      return null;
    },
    redirect() {
      if (this.paymentMethod === 0) {
        return '/profile/invoicing/plans';
      } else {
        return '/cloud';
      }
    }
  },
  methods: {
    redirectInfo() {
      if (this.paymentMethod === 0) {
        this.$router.push({ path: '/profile/invoicing/plans' });
      } else {
        this.$router.push({ path: '/cloud' });
      }
    }
  }
};
</script>